import api from '../../../api/client';
import React, { useState, useEffect } from "react";
import { Select } from "antd";
import dayjs from "dayjs";

const { Option } = Select;

const PayrollPeriodSelect = ({ selectedPeriod, setSelectedPeriod }) => {
  const [periodOptions, setPeriodOptions] = useState([]);

  useEffect(() => {
    const generatePeriodOptions = () => {
      const options = [];
      for (let i = 0; i < 12; i++) {
        const date = dayjs().subtract(i, "month");
        const value = date.format("YYYY-MM");
        const label = date.format("MMMM YYYY");
        options.push({ value, label });
      }
      return options;
    };
    setPeriodOptions(generatePeriodOptions());
  }, []);

  return (
    <Select
      placeholder="Select payroll period..."
      style={{ width: "100%" }}
      value={selectedPeriod}
      onChange={setSelectedPeriod}
      allowClear
      showSearch
      optionFilterProp="children"
    >
      {periodOptions.map((opt) => (
        <Option key={opt.value} value={opt.value}>
          {opt.label}
        </Option>
      ))}
    </Select>
  );
};

export default PayrollPeriodSelect;